import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
// import { ToastContainer, toast } from "react-toastify";
import {
  FetchOwnerHorsesDropDownthunk,
} from "../Redux/OwnerProfile/OwnerProfileAction";
import {
} from "../Redux/StudBook/StudBookAction";
import {
  FetchApproveRejectRequestthunk,
  FetchCancelRequestthunk,
  FetchCreateOwnerShipTransferServicesRequeststhunk,
  FetchGetCovCerByHorseIdthunk,
  FetchGetDocumentTypesByServiceIdthunk,
  FetchGetFilebase64thunk,
  FetchGetServiceDefinitionByIdthunk,
  FetchGetServicesRequestByIdthunk,
  FetchUpdateOwnerShipTransferServicesRequeststhunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
  resetGetServicesRequestByIdData,
  resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import AsyncSelect from "react-select/async";
import axiosInstance from "../axios/axios";
import { formatDate } from "../helper/formatDate";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import Popup from "reactjs-popup";
import { base64ToBlob } from "../helper/base64ToBlob";
import SimpleFileUpload from "../components/SimpleFileUpload";
import { isMoreThanOneYearBeforeToday } from "../helper/isMoreThanOneYearBeforeToday";
import dayjs from "dayjs";
import { toast, ToastContainer } from "react-toastify";
import { isLessThanUndefinedYearOld } from "../helper/isLessThanUndefinedYearOld";
import EahsForm from "../components/EahsForm";
import PillBtn from "../components/PillBtn";
import CancelBtn from "../components/servicesButtons/CancelBtn";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import RejectBtn from "../components/servicesButtons/RejectBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import ApproveAndPayBtn from "../components/servicesButtons/ApproveAndPayBtn";
import { eFormButtonsContainer, eformCheckBox, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import CustomPopUp from "../components/CustomPopUp";
import { Link } from "react-router-dom";

export default function RequestHorseOwnershipTransferSeller() {
  //env
  const UMBRACOURL = process.env.REACT_APP_UMBRACO;
  // const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  const [isSelectedMareCoverd, setIsSelectedmareCoverd] = useState(2)

  //selector
  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const { ownerHorsesDropDownData } = useSelector(
    (state) => state.ownerProfileSlice
  );
  const {
    toasterMessageServicesRequests,
    servicesRequestsLoading,
    getServicesRequestByIdData,
    getServiceDefinitionByIdData,
    getFilebase64Data,
    getDocumentTypesByServiceIdData,
    createOwnerShipTransferServicesRequestsData,
    covCerByHorseIdData,
  } = useSelector((state) => state.servicesRequestsSlice);

  const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
  const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

  //dispatch
  const dispatch = useDispatch();

  //translate
  const { translate } = useTranslate();

  //navigate
  const navigate = useNavigate();

  //Location
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : null;

  const id = searchParams.has("id") ? searchParams.get("id") : null;

  const action = searchParams.has("action") ? searchParams.get("action") : null;
  const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

  //state
  const [formModel, setFormModel] = useState({
    id: "",
    horse: "",
    horseDrop: {
      label: translate("web.horse", "Horse"),
      value: "",
    },
    regNo: "",
    horseName: "",
    gender: "",
    color: "",
    birthDate: "",
    sire: "",
    dam: "",
    origin: "",
    breeder: "",
    owner: "",
    ownerDrop: {
      label: translate("web.owner", "owner"),
      value: "",
    },
    ownerName: "",
    ownerRegNo: "",
    country: "",
    city: "",
    area: "",
    phone: "",
    email: "",
    idNumber: "",
    employeeId: "",
    buyerComment: "",
    eventName: "",
    attachmentFile: null,
    comment: "",
    referenceNumber: "",
    address: "",
    mobile: "",
    filePath: "",
    fileType: "",
    fileName: "",
    documentType: "",
    documentTypeDrop: {
      label: translate("web.type", "Type"),
      value: "",
    },
    isRegistration: true,
    requestsType: "",
    effectiveDate: null,
    isCollectSemen: "No",
    numberOfDoses: 0,

    // Covering Certificate
    isMareCovered: false,    // maps -> IsMareCovered
    coveringCertificateId: "", // maps -> CoveringCertificateId
    coveringCertificateNo: "", // للعرض فقط في حالة edit/view
    stallionName: "",          // للعرض فقط
    coveringDate: "",          // للعرض فقط (YYYY-MM-DD أو DD/MM/YYYY للعرض)
  });

  const coveringCertificateNoRef = useRef(null);

  // ----- errors -----
  const [errorCoveringCertificateId, setErrorCoveringCertificateId] = useState(false);

  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupCancel, setOpenPopupCancel] = useState(false);
  const [ownerListLoading, setOwnerListLoading] = useState(false);

  const _isOnlinePayment = useRef("");
  const _status = useRef("");

  const checkAnotherOwner = useRef(true);

  const [inputValue, setInputValue] = useState("");
  const [timeoutId, setTimeoutId] = useState(0);
  const [uploadAttachmentFile, setUploadAttachmentFile] = useState([]);

  const [checkedItems, setCheckedItems] = useState({});

  // const [checkedItems, setCheckedItems] = useState({
  //   option1: false,
  //   option2: false,
  //   option3: false,
  // });

  const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage == "en" ? "" : "Ar"}`],
    value: localStorage.getItem("EAHSUserID"),
  });

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };
  const subAccountId = localStorage.getItem("currentSubAccountId");
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);

  const [errorHorse, setErrorHorse] = useState(false);
  const [errorBuyer, setErrorBuyer] = useState(false);
  const [errorOwnershipTransferDate, setErrorOwnershipTransferDate] = useState(false);
  const [errorNumberOfSemenDoses, setErrorNumberOfSemenDoses] = useState(false);
  const [errorSupportDocument, setErrorSupportDocument] = useState(false);
  const [errorDocumentType, setErrorDocumentType] = useState(false);
  const [errorAddress, setErrorAddress] = useState(false);
  const [errorMobile, setErrorMoble] = useState(false);
  const [errorMmareIsCoverdError, setErrorMmareIsCoverdError] = useState(false);

  // state ref
  const horseRef = useRef(null);
  const mareIsCoverdRef = useRef(null);
  const buyerRef = useRef(null);
  const ownershipTransferDateRef = useRef(null);
  const numberOfSemenDosesRef = useRef(null);
  const supportDocumentRef = useRef(null);
  const documentTypeRef = useRef(null);
  const addressRef = useRef(null);
  const mobileRef = useRef(null);

  //function
  const setPhoneNumber = (value) => {
    setFormModel((prev) => ({
      ...prev,
      mobile: value
    }));
  }

  const handleFormChange = (e, input) => {
    // if (input === "horse") {
    //   let horse = ownerHorsesDropDownData.filter((item) => item.id == e.value);

    //   setFormModel({
    //     ...formModel,
    //     horseDrop: e,
    //     horse: e.value,
    //     regNo: horse[0].registerNumber,
    //     horseName: horse[0].name,
    //     gender: horse[0].gender,
    //     color: horse[0].color,
    //     birthDate: horse[0].birthDate,
    //     sire: horse[0].sire,
    //     dam: horse[0].dam,
    //     origin: horse[0].origin,
    //     breeder: horse[0].breeder,
    //     isCollectSemen: "No",
    //     numberOfDoses: 0
    //   });
    // }
    if (input === "horse") {
      const horse = ownerHorsesDropDownData.find(item => item.id == e.value);

      // لو Mare هات الشهادة الجارية (إن وجدت)
      if (e.value && horse?.gender === "Mare") {
        dispatch(FetchGetCovCerByHorseIdthunk({
          horseId: e.value,
          ownerId: getUserID(),
        }));
      }

      setFormModel({
        ...formModel,
        horseDrop: e,
        horse: e.value,
        regNo: horse?.registerNumber,
        horseName: horse?.name,
        gender: horse?.gender,
        color: horse?.color,
        birthDate: horse?.birthDate,
        sire: horse?.sire,
        dam: horse?.dam,
        origin: horse?.origin,
        breeder: horse?.breeder,
        isCollectSemen: "No",
        numberOfDoses: 0,

        // تصفير بيانات الـ Covering Certificate عند تغيير الحصان
        isMareCovered: false,
        coveringCertificateId: "",
        coveringCertificateNo: "",
        stallionName: "",
        coveringDate: "",
      });
    }

    else if (input === "owner") {
      if (e?.value != null && e?.value != undefined) {
        setFormModel({
          ...formModel,
          ownerDrop: e,
          owner: e.value,
          email: e.details.email,
          phone: e.details.phone,
          idNumber: e.details.idNumber,
        });
      }
    }
    else if (input === "isMareCovered") {
      const yes = (e.target?.value ?? e) === "true" || e === true;
      setFormModel({
        ...formModel,
        isMareCovered: yes,
        // لو No صفّر الـ Id
        //coveringCertificateId: yes ? formModel.coveringCertificateId : null,
      });
    }

    else if (input === "documentType") {
      setFormModel({
        ...formModel,
        documentTypeDrop: e,
        documentType: e.value,
      });
    } else if (input === "receiveType") {
      setFormModel({
        ...formModel,
        isRegistration: e.target.value === "Registration" ? true : false,
      });
    } else if (!!input && input === "effectiveDate") {
      setFormModel({
        ...formModel,
        effectiveDate: e.target.value,
        // effectiveDate: e,
      });
    } else if (!!input && input === "isCollectSemen") {
      setFormModel({
        ...formModel,
        isCollectSemen: e.target.value,
        numberOfDoses: e.target.value === "No" ? 0 : formModel.numberOfDoses
      });
    } else {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value,
      });
    }
  };

  const dismissAll = () => toast.dismiss();

  const validInputs = () => {
    let valid = true;

    if (
      formModel.gender === "Mare"
    ) {
      if (isSelectedMareCoverd == 2) {
        setErrorMmareIsCoverdError(true);
        valid = false;

        mareIsCoverdRef?.current?.focus();
        return;
      } else {
        setErrorMmareIsCoverdError(false);
      }
    }

    if (
      formModel.horse === ""
    ) {
      setErrorHorse(true);
      valid = false;

      horseRef?.current?.focus();
      return;
    }
    else {
      setErrorHorse(false);
    }

    // شرطنا: لو الجنس Mare و IsMareCovered = Yes لازم CoveringCertificateId
    if (formModel.gender === "Mare" && formModel.isMareCovered) {
      if (!formModel.coveringCertificateId) {
        setErrorCoveringCertificateId(true);
        valid = false;
        coveringCertificateNoRef?.current?.focus();
        // ممكن كمان show toast: "No Valid Covering Certificate"
      } else {
        setErrorCoveringCertificateId(false);
      }
    } else {
      setErrorCoveringCertificateId(false);
    }

    if (
      formModel.owner === ""
    ) {
      setErrorBuyer(true);
      valid = false;

      buyerRef?.current?.focus();
      return;
    }
    else {
      setErrorBuyer(false);
    }

    if (
      formModel.effectiveDate === null
    ) {
      setErrorOwnershipTransferDate(true);
      valid = false;

      ownershipTransferDateRef?.current?.focus();
      return;
    }
    else {
      setErrorOwnershipTransferDate(false);
    }

    if (!!formModel.gender && formModel.gender.toLowerCase() === "STALLION".toLowerCase() && !!formModel.birthDate && !isLessThanUndefinedYearOld(new Date(formModel.birthDate), 2) && formModel.isCollectSemen === "Yes" && (formModel.numberOfDoses === "" || Number(formModel.numberOfDoses) < 1)) {
      // toast.error(
      //   translate(
      //     "web.pleaseAddNumberOfDoses",
      //     "Please Add Number Of Doses"
      //   )
      // );

      setErrorNumberOfSemenDoses(true);
      valid = false;

      numberOfSemenDosesRef?.current?.focus();
      return;
    }
    else {
      setErrorNumberOfSemenDoses(false);
    }

    // if (
    //   formModel.documentType !== "" && formModel.attachmentFile == null
    // ) {
    //   setErrorSupportDocument(true);
    //   valid = false;

    //   supportDocumentRef?.current?.focus();
    //   return;
    // }
    // else {
    //   setErrorSupportDocument(false);
    // }

    if (
      (action == null || action === "edit" || action === "approve") &&
      formModel.attachmentFile != null &&
      (formModel.documentType === "" || formModel.documentType === null)

    ) {
      //translate("web.pleaseSelectDocumentType", "Please Select Document Type")
      setErrorDocumentType(true);
      valid = false;

      documentTypeRef?.current?.focus();
      return;
    }
    else {
      setErrorDocumentType(false);
    }

    if (
      formModel.eventName === "SentBack" &&
      !formModel.isRegistration &&
      (formModel.address === "" || formModel.address == null || formModel.address.length < 50)
    ) {
      // toast.error(
      //   translate(
      //     "web.pleaseenteryouraddressandmobilenumber",
      //     "Please enter your address and mobile number"
      //   )
      // );
      setErrorAddress(true);
      valid = false;

      addressRef?.current?.focus();

      toast.error(
        translate("web.errorAddressLength50Chars", "Can not address length less than 50 characters")
      );

      return;
    }
    else {
      setErrorAddress(false);
    }

    if (
      formModel.eventName === "SentBack" &&
      !formModel.isRegistration &&
      (formModel.mobile === "" || formModel.mobile == null)
    ) {
      setErrorMoble(true);
      valid = false;

      mobileRef?.current?.focus();
      return;
    }
    else {
      setErrorMoble(false);
    }

    //terms
    if (Object.values(checkedItems).length > 0) {  // Optional safe check
      const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

      if (!allTermsChecked && action == null) {
        toast.error(
          translate("web.pleaseCheckAllTerms", "Please Check All Terms")
        );
        valid = false;
      }
    }

    // if (
    //   !checkedItems.option1
    //   || !checkedItems.option2
    //   || !checkedItems.option3
    // ) {
    //   toast.error(
    //     translate("web.pleaseCheckAllTerms", "Please Check All Terms")
    //   );
    //   valid = false;
    // }

    return valid;
  }

  const handelFormSubmit = (status, buttonAction = 'Draft') => {
    _status.current = status;

    if (
      validInputs()
    ) {
      let params = {
        id: id,
        serviceDefinitionId: serviceId,
        // employeeId:
        //   formModel.eventName == "SentBack"
        //     ? formModel.employeeId
        //     : localStorage.getItem("EAHSUserID"),
        employeeId: localStorage.getItem("EAHSUserID"),
        date: new Date().toISOString(),
        status: formModel.eventName === "SentBack" ? "PendingReview" : status,
        //status: status == "BuyerApproved" ? "WatingBuyerApproval" : status,
        comment: formModel.buyerComment,
        buttonAction: buttonAction,
        requestDetails: {
          horseId: formModel.horse,
          // ownerId:
          //   formModel.eventName == "SentBack"
          //     ? formModel.employeeId
          //     : localStorage.getItem("EAHSUserID"),
          ownerId:
            formModel.eventName === "SentBack"
              ? formModel.employeeId
              : getUserID(),
          newOwnerId: formModel.owner,
          attachmentFile: formModel.attachmentFile,
          documentTypeId: formModel.documentType,
          effectiveDate: dayjs(formModel.effectiveDate).format("DD/MM/YYYY"),
          isCollectSemen: formModel.isCollectSemen === "Yes",
          numberOfDoses: formModel.numberOfDoses,
          address: formModel.address,
          mobile: formModel.mobile,
          receiveType: formModel.isRegistration ? 1 : 2,
          createdBy: localStorage.getItem("EAHSUserID"),
          // Covering (send)
          isMareCovered: formModel.gender === "Mare" ? formModel.isMareCovered : "",
          coveringCertificateId:
            formModel.gender === "Mare" && formModel.isMareCovered
              ? formModel.coveringCertificateId || ""
              : "",

        },
      };

      if (action == null) {
        //statusRequest.current = "new";
        dispatch(FetchCreateOwnerShipTransferServicesRequeststhunk(params));
      } else if (action === "edit" || formModel.eventName === "SentBack") {
        //statusRequest.current = "edit";
        dispatch(FetchUpdateOwnerShipTransferServicesRequeststhunk(params));
      }
    } else {
      toast.error(
        translate("web.completeTheRequiredData", "Complete The Required Data")
        //translate("web.completeMissingData", "Complete The Missing Data")
      );
    }
  };

  const handelApproveRejectRequest = (status, isOnlinePayment) => {
    _status.current = status;
    _isOnlinePayment.current = isOnlinePayment;

    if (
      !formModel.isRegistration &&
      (formModel.address === "" || formModel.address == null || formModel.address.length < 50)
    ) {

      setErrorAddress(true);

      addressRef?.current?.focus();

      toast.error(
        translate("web.errorAddressLength50Chars", "Can not address length less than 50 characters")
      );

      return;
    }
    else {
      setErrorAddress(false);
    }

    if (
      !formModel.isRegistration &&
      (formModel.mobile === "" || formModel.mobile == null)
    ) {

      setErrorMoble(true);

      mobileRef?.current?.focus();
      return;
    }
    else {
      setErrorMoble(false);
    }

    let params = {
      id: id,
      // employeeId: formModel.employeeId,
      employeeId: getUserID(),
      status: status,
      comment: formModel.buyerComment,
      address: formModel.address,
      mobile: formModel.mobile,
      receiveType: formModel.isRegistration ? 1 : 2,
    };

    dispatch(FetchApproveRejectRequestthunk(params));

  };

  const handleUploadServiceRequestDocumentChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setFormModel({
          ...formModel,
          attachmentFile: e.target.files[0],
        });

        setUploadAttachmentFile([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };

  const handelSelectedAccountChange = async (element) => {
    let params = {
      ownerId: element.value,
      skip: 0,
      take: 1000,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: "",
      sortBy: "-1",
    };
    dispatch(FetchOwnerHorsesDropDownthunk(params));

    setProfile(element);

    setFormModel({
      ...formModel,
      horse: "",
      horseDrop: {
        label: translate("web.horse", "Horse"),
        value: "",
      },
      gender: "",
      color: "",
      birthDate: "",
      sire: "",
      dam: "",
      origin: "",
      breeder: "",
    });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));

  };

  const closeModal = () => setOpenPopup(false);
  const closeModalCancel = () => setOpenPopupCancel(false);

  function CheckIfAgentHasPermission() {
    const AgentHasPermission = userProfile.subAccounts
      .filter((x) => x.value == subAccountId)[0]
      .ownersPermissionsList.some(
        (x) =>
          x.permissionName === "OwnerShipTransfer" || x.permissionName === "All"
      );
    return AgentHasPermission;
  }

  const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.isAgent != true ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };
  const getSelectedAccountName = () => {
    const selectAccount = userProfile.subAccounts.filter(
      (x) => x.value == subAccountId
    );

    if (selectAccount.length > 0) {
      return selectAccount[0];
    }
    else {
      return false;
    }
  };

  const handelCancelRequest = () => {
    let params = {
      serviceId: id,
      ownerId: localStorage.getItem("EAHSUserID"),
    };

    dispatch(FetchCancelRequestthunk(params));
  };

  // asyunc search
  const promiseOptions = (searchKeyword) =>
    new Promise((resolve) => {
      if (timeoutId > 0) {
        clearTimeout(timeoutId);
      }

      const id = setTimeout(async () => {
        const response = await axiosInstance.post(
          "/StudBook/FilterOwnersOrUsers",
          {
            langauge: localStorage.getItem("eahsLang") ?? "en",
            ownerId: searchKeyword,
            skip: 0,
            take: 10000,
            tableType: "user",
          }
        );

        const data = await response.data.ownersList;

        const options = data.map((item) => ({
          label: item.ownerId + " - " + item.name,
          value: item.id,
          details: item,
        }));
        resolve(options);
      }, 1000);

      setTimeoutId(id);
    });

  //Effect
  useEffect(() => {
    if (covCerByHorseIdData && Object.keys(covCerByHorseIdData).length > 0) {
      console.log("covCerByHorseIdData", covCerByHorseIdData);
      setFormModel(prev => ({
        ...prev,
        // بمجرد ما المستخدم يختار "Yes" هنبعتها
        coveringCertificateId: covCerByHorseIdData.id || "",
        coveringCertificateNo: covCerByHorseIdData.referenceNumber || "",
        stallionName: covCerByHorseIdData.stallionName || "",
        coveringDate: covCerByHorseIdData.coveringDate
          ? dayjs(covCerByHorseIdData.coveringDate).format("YYYY-MM-DD")
          : "",
      }));
    }
  }, [covCerByHorseIdData]);

  useEffect(() => {
    if (!!userProfile && userProfile?.haveProfileSignture != true) {

      toast.error(
        translate(
          "web.completeOwnerProfileData",
          "Please complete the personal data of the profile."
        )
      );

      setTimeout(() => {
        navigate("/profile");
      }, 3000);
    }

    if (!!userProfile && userProfile?.accountType === "Agent") {
      if (userProfile.id == subAccountId) {
        navigate("/403-Not-Authrized");
      }

      if (!CheckIfAgentHasPermission()) {
        navigate("/403-Not-Authrized");
      }
    }

    let params = {
      ownerId: getUserID(),
      skip: 0,
      take: 1000,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: "",
      sortBy: "-1",
    };
    dispatch(FetchOwnerHorsesDropDownthunk(params));

    let subOwnerProfilesParams = {
      id: getUserID(),
      langauge: currentLanguage,
    };
    dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

    dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));

    let documentTypesParams = {
      id: serviceId,
      language: currentLanguage,
    };
    dispatch(FetchGetDocumentTypesByServiceIdthunk(documentTypesParams));

    //dispatch(FetchGetOwnersListthunk(currentLanguage));

    return () => {
      // You Should Reset the getServicesRequestByIdData to the init status
    }

  }, [currentLanguage]);

  useEffect(() => {
    if (
      getServicesRequestByIdData != null &&
      Object.keys(getServicesRequestByIdData).length > 0 &&
      checkAnotherOwner.current && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
    ) {
      if (ownerHorsesDropDownData.length > 0) {
        setFormModel({
          ...formModel,
          horse: getServicesRequestByIdData.ownerShipTransfer.horseId,
          horseDrop: {
            label:
              getServicesRequestByIdData.ownerShipTransfer.horse
                .registrationNumber +
              " - " +
              getServicesRequestByIdData.ownerShipTransfer.horse.nameEn,
            value: getServicesRequestByIdData.ownerShipTransfer.horseId,
          },
          regNo:
            getServicesRequestByIdData.ownerShipTransfer.horse
              .registrationNumber,
          horseName: getServicesRequestByIdData.ownerShipTransfer.horse.nameEn,
          gender: getServicesRequestByIdData.ownerShipTransfer.horse.gender,
          color:
            currentLanguage === "en"
              ? getServicesRequestByIdData.ownerShipTransfer.horse.horseColor
                .nameEn
              : getServicesRequestByIdData.ownerShipTransfer.horse.horseColor
                .nameAr,
          birthDate:
            getServicesRequestByIdData.ownerShipTransfer.horse.birthDate,
          sire: getServicesRequestByIdData.ownerShipTransfer.horse.sireNameEn,
          dam: getServicesRequestByIdData.ownerShipTransfer.horse.damNameEn,

          employeeId:
            getServicesRequestByIdData.requestsType == "Portal"
              ? getServicesRequestByIdData.ownerShipTransfer.createdBy
              : getServicesRequestByIdData.ownerShipTransfer.ownerId,
          owner: getServicesRequestByIdData.ownerShipTransfer.newOwnerId,
          ownerDrop: {
            label:
              getServicesRequestByIdData.ownerId +
              " - " +
              getServicesRequestByIdData.ownerName,
            value: getServicesRequestByIdData.ownerShipTransfer.newOwnerId,
          },
          phone: getServicesRequestByIdData.ownerPhone,
          email: getServicesRequestByIdData.ownerEmail,
          idNumber: getServicesRequestByIdData.idNumber,
          eventName: getServicesRequestByIdData.eventName,
          comment: getServicesRequestByIdData.comment,
          requestsType: getServicesRequestByIdData.requestsType,
          referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,
          buyerComment: getServicesRequestByIdData.ownerShipTransfer.buyerComment != null ? getServicesRequestByIdData.ownerShipTransfer.buyerComment : "",
          effectiveDate: getServicesRequestByIdData.ownerShipTransfer.effectiveDate != null ? dayjs(getServicesRequestByIdData.ownerShipTransfer.effectiveDate).format("YYYY-MM-DD") : null,
          isCollectSemen: getServicesRequestByIdData.ownerShipTransfer.isCollectSemen == true ? "Yes" : "No",
          numberOfDoses: getServicesRequestByIdData.ownerShipTransfer.numberOfDoses,
          address: getServicesRequestByIdData.ownerShipTransfer.address,
          mobile: getServicesRequestByIdData.ownerShipTransfer.mobile,
          isRegistration: getServicesRequestByIdData.ownerShipTransfer.isRegistration,
          filePath: getServicesRequestByIdData.ownerShipTransfer.filePath,
          fileType: getServicesRequestByIdData.ownerShipTransfer.fileType,
          fileName: getServicesRequestByIdData.ownerShipTransfer.fileName,
          breeder: getServicesRequestByIdData.ownerShipTransfer.horse.breeder,
          origin: getServicesRequestByIdData.ownerShipTransfer.horse.exportCountry,
          documentType: getServicesRequestByIdData.ownerShipTransfer.documentTypeId ?? "",
          documentTypeDrop: {
            label: getServicesRequestByIdData.ownerShipTransfer.documentTypeName,
            value: getServicesRequestByIdData.ownerShipTransfer.documentTypeId ?? "",
          },

          // Covering Certificate mapping
          isMareCovered: !!getServicesRequestByIdData.ownerShipTransfer.isMareCovered, // bool?
          coveringCertificateId: getServicesRequestByIdData.ownerShipTransfer.coveringCertificateId ?? "",
          coveringCertificateNo: getServicesRequestByIdData.ownerShipTransfer.coveringCertificateNo ?? "",
          stallionName: getServicesRequestByIdData.ownerShipTransfer.stallionName ?? "",
          coveringDate: getServicesRequestByIdData.ownerShipTransfer.coveringDate ? dayjs(getServicesRequestByIdData.ownerShipTransfer.coveringDate).format("YYYY-MM-DD") : "",
        });
      } else {
        setFormModel({
          ...formModel,
          horse: getServicesRequestByIdData.ownerShipTransfer.horseId,
          horseDrop: {
            label:
              getServicesRequestByIdData.ownerShipTransfer.horse
                .registrationNumber +
              " - " +
              getServicesRequestByIdData.ownerShipTransfer.horse.nameEn,
            value: getServicesRequestByIdData.ownerShipTransfer.horseId,
          },
          regNo:
            getServicesRequestByIdData.ownerShipTransfer.horse
              .registrationNumber,
          horseName: getServicesRequestByIdData.ownerShipTransfer.horse.nameEn,
          gender: getServicesRequestByIdData.ownerShipTransfer.horse.gender,
          color:
            currentLanguage === "en"
              ? getServicesRequestByIdData.ownerShipTransfer.horse.horseColor
                .nameEn
              : getServicesRequestByIdData.ownerShipTransfer.horse.horseColor
                .nameAr,
          birthDate:
            getServicesRequestByIdData.ownerShipTransfer.horse.birthDate,
          sire: getServicesRequestByIdData.ownerShipTransfer.horse.sireNameEn,
          dam: getServicesRequestByIdData.ownerShipTransfer.horse.damNameEn,

          employeeId:
            getServicesRequestByIdData.requestsType === "Portal"
              ? getServicesRequestByIdData.ownerShipTransfer.createdBy
              : getServicesRequestByIdData.ownerShipTransfer.ownerId,
          owner: getServicesRequestByIdData.ownerShipTransfer.newOwnerId,
          ownerDrop: {
            label:
              getServicesRequestByIdData.ownerId +
              " - " +
              getServicesRequestByIdData.ownerName,
            value: getServicesRequestByIdData.ownerShipTransfer.newOwnerId,
          },
          phone: getServicesRequestByIdData.ownerPhone,
          email: getServicesRequestByIdData.ownerEmail,
          idNumber: getServicesRequestByIdData.idNumber,
          eventName: getServicesRequestByIdData.eventName,
          requestsType: getServicesRequestByIdData.requestsType,
          comment: getServicesRequestByIdData.comment,
          referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,
          buyerComment: getServicesRequestByIdData.ownerShipTransfer.buyerComment != null ? getServicesRequestByIdData.ownerShipTransfer.buyerComment : "",
          effectiveDate: getServicesRequestByIdData.ownerShipTransfer.effectiveDate != null ? dayjs(getServicesRequestByIdData.ownerShipTransfer.effectiveDate).format("YYYY-MM-DD") : null,
          isCollectSemen: getServicesRequestByIdData.ownerShipTransfer.isCollectSemen == true ? "Yes" : "No",
          numberOfDoses: getServicesRequestByIdData.ownerShipTransfer.numberOfDoses,
          address: getServicesRequestByIdData.ownerShipTransfer.address,
          mobile: getServicesRequestByIdData.ownerShipTransfer.mobile,
          isRegistration: getServicesRequestByIdData.ownerShipTransfer.isRegistration,
          filePath: getServicesRequestByIdData.ownerShipTransfer.filePath,
          fileType: getServicesRequestByIdData.ownerShipTransfer.fileType,
          fileName: getServicesRequestByIdData.ownerShipTransfer.fileName,
          breeder: getServicesRequestByIdData.ownerShipTransfer.horse.breeder,
          origin: getServicesRequestByIdData.ownerShipTransfer.horse.exportCountry,
          documentType: getServicesRequestByIdData.ownerShipTransfer.documentTypeId ?? "",
          documentTypeDrop: {
            label: getServicesRequestByIdData.ownerShipTransfer.documentTypeName,
            value: getServicesRequestByIdData.ownerShipTransfer.documentTypeId ?? "",
          },

          // Covering Certificate mapping
          isMareCovered: !!getServicesRequestByIdData.ownerShipTransfer.isMareCovered, // bool?
          coveringCertificateId: getServicesRequestByIdData.ownerShipTransfer.coveringCertificateId ?? "",
          coveringCertificateNo: getServicesRequestByIdData.ownerShipTransfer.coveringCertificateNo ?? "",
          stallionName: getServicesRequestByIdData.ownerShipTransfer.stallionName ?? "",
          coveringDate: getServicesRequestByIdData.ownerShipTransfer.coveringDate ? dayjs(getServicesRequestByIdData.ownerShipTransfer.coveringDate).format("YYYY-MM-DD") : "",
        });
      }
      if(getServicesRequestByIdData?.ownerShipTransfer?.isMareCovered == true){
        setIsSelectedmareCoverd(1)
      }
      if(getServicesRequestByIdData?.ownerShipTransfer?.isMareCovered == false){
        setIsSelectedmareCoverd(0)
      }

      if (
        getServicesRequestByIdData.ownerShipTransfer.filePath != null &&
        getServicesRequestByIdData.ownerShipTransfer.filePath !== ""
      ) {
        dispatch(
          FetchGetFilebase64thunk(
            getServicesRequestByIdData.ownerShipTransfer.filePath
          )
        );
        // setUploadAttachmentFile({
        //   file: getServicesRequestByIdData.ownerShipTransfer.attachmentUrl,
        //   name: getServicesRequestByIdData.ownerShipTransfer.attachmentUrl.substr(
        //     getServicesRequestByIdData.ownerShipTransfer.attachmentUrl.lastIndexOf(
        //       "/"
        //     ) + 1
        //   ),
        // });
      }

      if (
        getServicesRequestByIdData.ownerShipTransfer.ownerId !==
        getServicesRequestByIdData.ownerShipTransfer.createdBy &&
        subOwnerProfilesByIdData.length > 0 &&
        getServicesRequestByIdData.requestsType !== "BackOffice" &&
        getServicesRequestByIdData.eventName !== "WatingBuyerApproval" &&
        getServicesRequestByIdData.eventName !== "SentBack"
      ) {
        let params = {
          ownerId: getServicesRequestByIdData.ownerShipTransfer.ownerId,
          skip: 0,
          take: 1000,
          langauge: currentLanguage,
          horseTypeFilter: "1",
          searchValue: "",
          sortBy: "-1",
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        //update checkAnotherOwner
        checkAnotherOwner.current = false;
        //update profile
        setProfile({
          label:
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.ownerShipTransfer.ownerId
            )[0]?.registerNo +
            " - " +
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.ownerShipTransfer.ownerId
            )?.[0]?.[`text${currentLanguage == "en" ? "" : "Ar"}`],
          value: subOwnerProfilesByIdData.filter(
            (item) =>
              item?.value == getServicesRequestByIdData.ownerShipTransfer.ownerId
          )?.[0]?.value,
        });
      }

      checkAnotherOwner.current = false;

      // setCheckedItems({
      //   option1: true,
      //   option2: true,
      //   option3: true,
      // });
    }
  }, [
    ownerHorsesDropDownData,
    getServicesRequestByIdData,
    subOwnerProfilesByIdData,
    getDocumentTypesByServiceIdData,

  ]);

  useEffect(() => {
    if (id != null) {
      let params = {
        language: currentLanguage,
        id: id,
        ownerId: getUserID(),
      };

      checkAnotherOwner.current = true;
      dispatch(FetchGetServicesRequestByIdthunk(params));
    }

    return () => {
      dispatch(resetGetServicesRequestByIdData());
    };
  }, [id]);

  useEffect(() => {
    //save
    if (
      toasterMessageServicesRequests != null &&
      toasterMessageServicesRequests === "save"
    ) {
      if (_status.current === "BuyerApproved") {
        toast.success(
          translate(
            "web.yourRequestHasSuccessfully",
            "Your Request Has Successfully"
          )
        );
      } else {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );
      }

      dispatch(resetToasterMessageServicesRequests());

      setTimeout(() => {
        if (_status.current === "BuyerApproved") {
          //go to payment
          //const returnUrl = `${BaseURL}/servicesrequestspaymentsuccessful?serviceRequestId=${id}`;
          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

          const encodeURI = encodeURIComponent(returnUrl);

          window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=7&userId=${localStorage.getItem(
            "EAHSUserID"
          )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
        } else {
          if (_status.current === "WatingBuyerApproval" && formModel.eventName !== "SentBack") {
            navigate(`/profile?activeTab=${"e_services"}&serviceId=${id == null ? createOwnerShipTransferServicesRequestsData?.id : id}`);
          }
          else {
            navigate(`/profile?activeTab=${"e_services"}`);
          }
        }
      }, 1000);
    }

    //error
    else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
      if (toasterMessageServicesRequests !== "errorServiceDetails") {

        toast.error(
          translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
        );

        dispatch(resetToasterMessageServicesRequests());
      }

      else if (toasterMessageServicesRequests === "errorServiceDetails") {
        toast.error(
          translate("web.createServiceRequestFailed", "Service Request Failed")
        );

        dispatch(resetToasterMessageServicesRequests());

        setTimeout(() => {
          navigate(`/profile?activeTab=${"e_services"}`);
        }, 1000);
      }
    }

  }, [toasterMessageServicesRequests]);

  useEffect(() => {
    if (getServiceDefinitionByIdData?.termsList) {
      const initialState = {};
      getServiceDefinitionByIdData.termsList.forEach((_, index) => {
        initialState[`option${index + 1}`] = false;
      });
      setCheckedItems(initialState);
    }
  }, [getServiceDefinitionByIdData?.termsList]);

  console.log("formModel", formModel);
  return (
    <>
      {/* loading div */}

      <div
        className={`page-overlay text-center ${servicesRequestsLoading || ownerListLoading
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>

      {/* toast */}
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />
      <div className={serviceRequestHeadContainer}>

        {/* title */}
        <h2 className={serviceRequestTitle}>
          {currentLanguage == "en"
            ? getServiceDefinitionByIdData.nameEn
            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
        </h2>
        {/* Selected Account */}
        {subOwnerProfilesByIdData.length > 0 &&
          (action == null || action === "edit") && (
            <div className={userDropDown}>
              {!!userProfile && userProfile?.accountType !== "Agent" ? (
                <>
                  <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[

                      ...(!!subOwnerProfilesByIdData &&
                        !!subOwnerProfilesByIdData.length > 0 &&
                        subOwnerProfilesByIdData.map((a) => ({
                          label:
                            a?.registerNo +
                            " - " +
                            a[`text${currentLanguage == "en" ? "" : "Ar"}`],
                          text:
                            a?.registerNo +
                            " - " +
                            a[`text${currentLanguage == "en" ? "" : "Ar"}`],
                          value: a.value,
                        }))),
                    ]} value={profile}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                    onChange={(e) => {
                      handelSelectedAccountChange(e);
                    }}
                  />
                </>
              ) : (
                getSelectedAccountName() != false &&

                <label className="capatalize_text">
                  {getSelectedAccountName()?.registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage == "en" ? "" : "Ar"}`
                    ]}
                </label>
              )}
            </div>
          )}
      </div>

      {/* horse */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horse", "Horse")}>
        <div className={eformInput}>
          <label> {translate("web.horse", "Horse")} <i className=" colorred">*</i> </label>
          <Select
            options={[
              {
                label: translate("web.horse", "Horse"),
                value: "",
              },
              ...(!!ownerHorsesDropDownData &&
                ownerHorsesDropDownData.map((a) => ({
                  label: a.registerNumber + " - " + a.name,
                  value: a.id,
                }))),
            ]}
            value={formModel.horseDrop}
            onChange={(e) => handleFormChange(e, "horse")}
            placeholder={translate("web.horse", "Horse")}
            name={"horse"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            isDisabled={
              action === "view" || action === "approve"
            }
            ref={horseRef}
          />
          {errorHorse && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.origin", "Origin")}
            name={"origin"}
            type={"text"}
            disabled={true}
            value={formModel.origin}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.breeder", "Breeder")}
            name={"breeder"}
            type={"text"}
            disabled={true}
            value={formModel.breeder}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.gender", "Gender")}
            name={"gender"}
            type={"text"}
            disabled={true}
            value={translate(
              `web._${formModel.gender.toLowerCase()}`,
              formModel.gender
            )}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.color", "Color")}
            name={"color"}
            type={"text"}
            disabled={true}
            value={formModel.color}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.birthDate", "Birth Date")}
            name={"birthDate"}
            type={"text"}
            disabled={true}
            value={
              formModel.birthDate != null && formModel.birthDate !== ""
                ? formModel.birthDate && formatDate(formModel.birthDate)
                : ""
            }
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.sire", "Sire")}
            name={"sire"}
            type={"text"}
            disabled={true}
            value={formModel.sire}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.dam", "Dam")}
            name={"dam"}
            type={"text"}
            disabled={true}
            value={formModel.dam}
          />
        </div>
      </EahsForm>

      {formModel.gender === "Mare" && (
        <EahsForm isSectionTitle ish3 className={'mb-main'} title={translate("web.coveringCertificateDetails", "Covering Certificate Details")}>
          <div className="row mx-0">
            <label>{translate("web.isSheFoalOwnerTTransfer", "isSheFoalOwnerTTransfer")}
              <i className=" colorred">*</i>
            </label>
            <div className={eformCheckBox}>

              <NetaqInput
                name="isMareCovered"
                type="radioServiceRequest"
                value={"true"}
                label={`${translate("web.yes", "Yes")}-`}
                checked={isSelectedMareCoverd == 1 && formModel.isMareCovered === true}
                onChange={(e) => { handleFormChange(e, "isMareCovered"); setIsSelectedmareCoverd(1) }}
                disabled={action === "view" || action === "approve"}
              />
            </div>
            <div className={eformCheckBox}>
              <NetaqInput
                name="isMareCovered"
                type="radioServiceRequest"
                value={"false"}
                label={`${translate("web.no", "No")}-`}
                checked={isSelectedMareCoverd == 0 && formModel.isMareCovered === false}
                onChange={(e) => { handleFormChange(e, "isMareCovered"); setIsSelectedmareCoverd(0) }}
                disabled={action === "view" || action === "approve"}
              />
            </div>
            {errorMmareIsCoverdError && <span className="text-danger">
              {translate("web.requiredField", "Required Field")}
            </span>}
          </div>

          {/* الحقول للعرض فقط، والـ Id هو المهم الذي يُرسل */}
          {formModel.isMareCovered && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <NetaqInput
                    label={translate("web.coveringCertificateNo", "Covering Certificate No")}
                    name="coveringCertificateNo"
                    type="text"
                    value={formModel.coveringCertificateNo}
                    disabled
                    ref={coveringCertificateNoRef}
                  />
                  {errorCoveringCertificateId && (
                    <span className="text-danger">
                      {translate("web.requiredField", "Required Field")}
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <NetaqInput
                    label={translate("web.stallion", "Stallion")}
                    name="stallionName"
                    type="text"
                    value={formModel.stallionName}
                    disabled
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <NetaqInput
                    label={translate("web.coveringDate", "Covering Date")}
                    name="coveringDate"
                    type="text"
                    value={formModel.coveringDate ? dayjs(formModel.coveringDate).format("DD/MM/YYYY") : ""}
                    disabled
                  />
                </div>
              </div>

              <div className="col-12 rtl">
                <Link
                  target="_blank"
                  to={
                    `/requestCoveringCertificate?serviceId=25341E00-BC23-49D7-99BD-61C9F976E73A`
                  }
                  className="red text-start"
                >
                  {translate(
                    "web.noValidCovCer",
                    "No Valid Covering Certificate"
                  )}

                </Link>
              </div>
            </>
          )}
        </EahsForm>
      )}

      {/* buyer owner */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.buyer", "Buyer")}>
        <div className={eformInput}>
          <label>
            {translate("web.owner", "Owner")}
            <i className=" colorred">*</i>
          </label>
          <AsyncSelect
            isClearable
            loadOptions={promiseOptions}
            defaultOptions={false} // Set to true to load initial options
            onInputChange={(newValue) => setInputValue(newValue)}
            inputValue={inputValue}
            value={formModel.ownerDrop}
            loadingMessage={() => translate("web.loading", "Loading")}
            onChange={(e) => handleFormChange(e, "owner")}
            placeholder={
              translate("web.typeToSearch", "Type To Search") + "..."
            }
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            isDisabled={action === "view" || action === "approve"}
            ref={buyerRef}
          />
          {errorBuyer && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.smsPhoneNo", "Mobile No")}
            name={"mobileNo"}
            type={"text"}
            disabled={true}
            value={formModel.phone}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate(
              "web.passportOrEmiratesId",
              "Passport - EmiratesId"
            )}
            name={"name"}
            type={"text"}
            disabled={true}
            value={formModel.idNumber}
            isDash={true}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.email", "Email")}
            name={"email"}
            type={"text"}
            disabled={true}
            value={formModel.email}
          />
        </div>
      </EahsForm>

      {/* ownership Transfer Data */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.ownershipTransferData", "Ownership Transfer Data")}>

        <div className={eformInput}>
          <NetaqInput
            htmlTags={
              formModel.effectiveDate ?
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  {
                    dayjs(formModel.effectiveDate).format("DD/MM/YYYY")
                  }
                </p> :
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  DD/MM/YYYY
                </p>
            }
            name={"effectiveDate"}
            type={"normalDateService"}
            label={translate("web.ownershipTransferDate", "Ownership Transfer Date")}
            onChange={(e) => handleFormChange(e, "effectiveDate")}
            value={formModel.effectiveDate}
            required={true}
            maxDate={dayjs().format("YYYY-MM-DD")}
            disabled={
              (action === "approve" || action === "view") ?
                true
                : false
            }
            ref={ownershipTransferDateRef}
          />
          {errorOwnershipTransferDate && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        {/* collect semen section */}
        {!!formModel.gender && formModel.gender.toLowerCase() === "STALLION".toLowerCase() && !!formModel.birthDate && !isLessThanUndefinedYearOld(new Date(formModel.birthDate), 2) &&
          <>
            <div className="col-md-4 col-sm-12 mb-1 rtl " style={{ maxWidth: 350 }}>
              <label className="capatalize_text">
                {
                  (action === null || action === "edit" || (action === "view" && (getServicesRequestByIdData.ownerShipTransfer.ownerId == getUserID() || getServicesRequestByIdData.ownerShipTransfer.createdBy == getUserID()))) &&

                  translate("web.doYouCollectSemenFromThisStallion", "Do You Collect Semen From This Stallion ?")
                }
                {
                  (action === "approve" || (action === "view" && getServicesRequestByIdData.ownerShipTransfer.newOwnerId == getUserID())) &&

                  translate("web.didSellerCollectSemen", "Did the seller collect the semen ?")
                }
              </label>
              <div className="AuctionFilterradioServiceRequestContainer mt-2 row">
                <div style={{ maxWidth: 150 }}>
                  <NetaqInput
                    name={"isCollectSemen"}
                    type={"radioServiceRequest"}
                    value={"No"}
                    label={`${translate("web.no", "NO")}`}
                    onChange={(e) => handleFormChange(e, "isCollectSemen")}
                    checked={
                      formModel.isCollectSemen === "No"
                    }
                    disabled={
                      (action === "approve" || action === "view") ?
                        true
                        : false
                    }
                  />
                </div>
                <div style={{ maxWidth: 150 }}>
                  <NetaqInput
                    name={"isCollectSemen"}
                    type={"radioServiceRequest"}
                    value={"Yes"}
                    label={`${translate("web.yes", "YES")}`}
                    onChange={(e) => handleFormChange(e, "isCollectSemen")}
                    checked={
                      formModel.isCollectSemen === "Yes"
                    }
                    disabled={
                      (action === "approve" || action === "view") ?
                        true
                        : false
                    }
                  />
                </div>
              </div>

            </div>
            {formModel?.isCollectSemen === "Yes" &&
              <>

                <div className="col-md-3 col-sm-12 mb-1  rtl" style={{ maxWidth: 306 }}>
                  <NetaqInput
                    name={"numberOfDoses"}
                    key={"numberOfDoses"}
                    type={"number"}
                    value={formModel.numberOfDoses}
                    minValue={1}
                    label={translate("web.numberOfDoses", "Number Of Doses")}
                    onChange={handleFormChange}
                    disabled={
                      (action === "approve" || action === "view") ?
                        true
                        : false
                    }
                    ref={numberOfSemenDosesRef}
                  />
                  {errorNumberOfSemenDoses && (
                    <span style={{ color: "red" }}>
                      {translate("web.requiredField", "Required Field")}
                    </span>
                  )}
                </div>
              </>
            }

          </>
        }
      </EahsForm>

      {/*upload attachment */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.uploadDocument", "Upload Document")}>


        {/* document type dropdown */}
        <div className={eformInput}>
          <label>
            {translate("web.documentType", "Document Type")}
          </label>
          <Select
            options={[
              {
                label: translate("web.type", "Type"),
                value: "",
              },
              ...(!!getDocumentTypesByServiceIdData &&
                getDocumentTypesByServiceIdData.map((a) => ({
                  label: a.nameEn,
                  value: a.id,
                }))),
            ]}
            value={formModel.documentTypeDrop}
            onChange={(e) => handleFormChange(e, "documentType")}
            placeholder={translate("web.type", "Type")}
            name={"documentType"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            isDisabled={
              action === "view" ||
                (action === "approve")
                ? true
                : false
            }
            ref={documentTypeRef}
          />
          {errorDocumentType && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        {/* document file */}
        <div className={eformInput}>
          <label >
            {translate(
              "web.serviceRequestDocumentType",
              "Supported Document (pdf,png)"
            )}
          </label>
          <SimpleFileUpload
            isMulti={false}
            initialFiles={
              formModel.filePath != null &&
                formModel.filePath != "" &&
                !!getFilebase64Data &&
                uploadAttachmentFile.length == 0
                ? [
                  {
                    file: base64ToBlob(
                      getFilebase64Data,
                      formModel.fileType === ".pdf"
                        ? "application/pdf"
                        : "image/png"
                    ),
                    name: formModel.fileName,
                  },
                ]
                : uploadAttachmentFile
            }
            isServer={
              formModel.filePath != null &&
                formModel.filePath != "" &&
                !!getFilebase64Data &&
                uploadAttachmentFile.length == 0
                ? true
                : false
            }
            onChange={handleUploadServiceRequestDocumentChange}
            accept={"image/*,application/pdf"}
            disabled={
              action === "view"
                //||(action === "approve" && formModel.eventName !== "SentBack")
                ? true
                : false
            }
            ref={supportDocumentRef}
          />
          {errorSupportDocument && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>
      </EahsForm>

      {/* Comments */}
      {((formModel.comment !== "" && formModel.comment != null) ||
        (formModel.buyerComment !== "" && formModel.buyerComment != null) ||
        action === "approve") && (
          <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>

            {/* eahs Comment */}
            {formModel.comment !== "" && formModel.comment != null && (
              <div className={eformInput}>
                <NetaqInput
                  label={translate("web.eahsComments", "EAHS Comments")}
                  name={"adminComment"}
                  type={"textarea"}
                  maxchars={1150}
                  value={formModel.comment}
                  disabled={true}
                />
              </div>
            )}

            {/* buyer Comment */}
            {((action === "approve") ||
              (action === "edit" &&
                formModel.eventName === "BuyerRejected") ||
              (action === "view" &&
                !!formModel.buyerComment)) && (
                <div className={eformInput}>
                  <NetaqInput
                    label={translate("web.buyerComments", "Buyer Comments")}
                    name={"buyerComment"}
                    type={"textarea"}
                    placeholder={translate(
                      "web.buyerComments",
                      "Buyer Comments"
                    )}
                    maxchars={1150}
                    onChange={handleFormChange}
                    value={formModel.buyerComment}
                    disabled={
                      action === "approve"
                        ? // (formModel.requestsType == "Portal" ||
                        //   formModel.eventName == "SentBack")
                        false
                        : true
                    }
                  />
                </div>
              )}
          </EahsForm>
        )}

      {/* How to receive a horse passport */}
      {((formModel.address !== "" && formModel.address != null) ||
        (formModel.mobile !== "" && formModel.mobile != null) ||
        action === "approve") && (
          <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(
            "web.receiveHorsePassport",
            "How to receive a horse passport"
          )}>
            <div className="AuctionFilterRadioContainer">
              <div style={{ margin: "auto 0" }}>
                <NetaqInput
                  name={"receiveType"}
                  key={"Registration"}
                  type={"radioServiceRequest"}
                  value={"Registration"}
                  label={translate(
                    "web.registrationOffice",
                    "Received From EAHS Office"
                  )}
                  onChange={(e) => handleFormChange(e, "receiveType")}
                  checked={
                    // formModel.isRegistration === true ? true : false
                    formModel.isRegistration
                  }
                  disabled={
                    action === "approve"
                      ? // (formModel.requestsType == "Portal" ||
                      //   formModel.eventName == "SentBack")
                      false
                      : true
                  }
                />
              </div>
              <div style={{ margin: "auto 30px" }}>
                <NetaqInput
                  name={"receiveType"}
                  key={"Post"}
                  type={"radioServiceRequest"}
                  value={"Post"}
                  label={translate("web.postOffice", "Post Delivery")}
                  onChange={(e) => handleFormChange(e, "receiveType")}
                  checked={
                    !formModel.isRegistration
                  }
                  disabled={
                    action === "approve"
                      ?
                      false
                      : true
                  }
                />
              </div>
            </div>

            {!formModel.isRegistration && (
              <>
                <div className={eformInput}>
                  <NetaqInput
                    label={translate("web.address", "Address")}
                    name={"address"}
                    type={"text"}
                    placeholder={translate("web.enterFullAddress", "Enter Full Address")}
                    onChange={handleFormChange}
                    value={formModel.address}
                    disabled={
                      action === "approve"
                        ? // (formModel.requestsType == "Portal" ||
                        //   formModel.eventName == "SentBack")
                        false
                        : true
                    }
                    required={true}
                    ref={addressRef}
                  />
                  {errorAddress && (
                    <span
                      ref={addressRef}
                      style={{ color: "red" }}>
                      {translate("web.requiredField", "Required Field")}
                    </span>
                  )}
                </div>

                <div className={eformInput}>
                  <NetaqInput
                    type={'phone'}
                    value={formModel.mobile}
                    label={translate("web.smsPhoneNo", "Mobile No")}
                    name={'mobile'}
                    placeholder={'971xxxxxxxxx'}
                    required={true}
                    onChange={setPhoneNumber}
                    setIsPhoneNumberValid={setIsPhoneNumberValid}
                    disabled={
                      action === "approve"
                        ? // (formModel.requestsType == "Portal" ||
                        //   formModel.eventName == "SentBack")
                        false
                        : true
                    }
                  />
                  {!isPhoneNumberValid &&
                    <div className='text-danger'>
                      {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                    </div>
                  }
                  {errorMobile && (
                    <span
                      style={{ color: "red" }}>
                      {translate("web.requiredField", "Required Field")}
                    </span>
                  )}
                </div>
              </>
            )}

          </EahsForm>
        )}

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
          return (
            <div className={eformTerms} key={index}>
              <NetaqInput
                type={"checkbox"}
                label={item}
                name={`option${index + 1}`}
                checked={checkedItems[`option${index + 1}`] || action != null}
                onChange={handleCheckboxChange}
                disabled={formModel.eventName !== ""}
              />
            </div>
          );
        })}
      </EahsForm>

      {/* <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ownershipTransferNote2",
              "This application is not valid without original passport"
            )}
            name="option1"
            checked={checkedItems.option1}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>

        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ownershipTransferNote3",
              "This application is not valid without original passport"
            )}
            name="option2"
            checked={checkedItems.option2}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          // onChange={() => {
          //   setcheckes(
          //     Array.from(
          //       document.querySelectorAll('input[type="checkbox"]')
          //     ).map((checkbox) => checkbox.checked)
          //   );
          // }}
          />
        </div>

        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ServiceGeneralNote",
              "Service General Note"
            )}
            name="option3"
            checked={checkedItems.option3}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
      </EahsForm> */}

      {/* buttons */}
      <div className={eFormButtonsContainer}>
        {/* cancel */}
        {(action === "edit" && formModel.eventName !== "Draft") &&
          <CancelBtn onClick={() => {
            setOpenPopupCancel((o) => !o);
          }} />
        }

        {/* draft */}
        {(formModel.eventName === "" || formModel.eventName === "Draft") && (
          <DraftBtn
            onClick={() => handelFormSubmit("Draft", 'Draft')}
          />
        )}

        {/* submit */}
        {(action == null ||
          action === "edit" ||
          (action === "approve" && formModel.eventName === "SentBack")) && (
            <SubmitServiceBtn onClick={() =>
              handelFormSubmit(
                action === "edit" && formModel.eventName === "BuyerRejected"
                  ? "WatingBuyerApproval"
                  : "WatingBuyerApproval", 'Submit'
              )
            } />
          )}

        {/* approve and reject */}
        {(action === "approve" && formModel.eventName !== "SentBack") && (
          <>
            <RejectBtn
              onClick={() => {
                setOpenPopup((o) => !o);
              }}
              spanText={
                `
       ${translate(
                  "web.rejectBuyerComments",
                  "*To Reject The Request Please Enter The Buyer Comments*"
                )}
     `
              }
              isDisabled={
                formModel.requestsType === "Portal" &&
                  formModel.buyerComment !== "" &&
                  formModel.buyerComment != null
                  ? false
                  : true
              } />

            {userProfile?.participateWithoutPayment == true && (
              <ApproveAndPayLaterBtn
                selectedAccountId={profile?.value}
                onClick={() =>
                  handelApproveRejectRequest("BuyerApproved", "no")
                } />
            )}

            <ApproveAndPayBtn selectedAccountId={profile?.value} onClick={() =>
              handelApproveRejectRequest("BuyerApproved", "yes")
            } />
          </>
        )}
      </div>

      {/* pop up for reject */}
      <CustomPopUp
        title={translate(
          "web.confirmMsgRejectrequest",
          "Are you sure to reject request?"
        )}
        open={openPopup}
        onClose={() => {
          setOpenPopup(false);
        }}
        btnText={translate("web.reject", "Reject")}
        onClick={() => {
          setOpenPopup((o) => !o);
          handelApproveRejectRequest("BuyerRejected");
        }} />

      {/* pop up for cancel */}
      <CustomPopUp
        title={translate(
          "web.confirmMsgCancelRequest",
          "Are you sure to cancel request?"
        )}
        btnText={translate("web.cancel", "Cancel")}
        open={openPopupCancel}
        onClose={() => {
          setOpenPopupCancel(false);
        }}
        onClick={() => {
          setOpenPopupCancel((o) => !o);
          handelCancelRequest();
        }}
      />
    </>
  );
}
